import React, { useState, useEffect, useContext, useCallback } from "react";
// https://fluentsite.z22.web.core.windows.net/quick-start
import { Provider, teamsTheme, Loader, Alert } from "@fluentui/react-northstar";
import { HashRouter as Router, Route } from "react-router-dom";
import { useTeamsFx } from "./lib/useTeamsFx";
import Privacy from "./Privacy";
import TermsOfUse from "./TermsOfUse";
import Main from "./Main";
import Voicemail from "./Voicemail"
import { Messaging } from "./Messaging"
import { Transcribe } from "./Transcribe"
import { useGraph } from "./lib/useGraph";
//import Nav from "./Nav";

import HPBXService from "../services/HPBXService";

import { updateUserProfile, updateUsers, updateHPBXQueues, updateHPBXOnlyUsers, updateGroups, updateContacts } from '../actions';

import { useSelector, useDispatch } from 'react-redux';

import { LeftRail } from "./LeftRail";

import "./App.css";

import PollerService from "../services/PollerService";

function getErrorDetails(error) {
  if (!error) {
    return "Unknown error";
  }

  if (typeof error === "string") {
    return error;
  }

  const parts = [];

  if (error.message) {
    parts.push(`Message: ${error.message}`);
  }

  if (error.code) {
    parts.push(`Code: ${error.code}`);
  }

  // Axios response received (4xx/5xx)
  if (error.response) {
    parts.push(`Status: ${error.response.status} ${error.response.statusText || ""}`);
    if (error.response.data) {
      try {
        const responseData = typeof error.response.data === "string"
          ? error.response.data
          : JSON.stringify(error.response.data);
        parts.push(`Response: ${responseData}`);
      } catch {
        // ignore serialisation error
      }
    }
  }

  // Axios config (URL + method)
  if (error.config) {
    if (error.config.url) {
      parts.push(`URL: ${error.config.url}`);
    }
    if (error.config.method) {
      parts.push(`Method: ${error.config.method.toUpperCase()}`);
    }
  }

  // No response received at all (pure network error)
  if (error.request && !error.response) {
    parts.push("No response received from server");
  }

  if (error.body) {
    parts.push(`Body: ${error.body}`);
  }

  if (parts.length > 0) {
    return parts.join(" | ");
  }

  try {
    return JSON.stringify(error);
  } catch {
    return "Unknown error";
  }
}


/**
 * The main app which handles the initialization and routing
 * of the app.
 */
export default function App() {


  const { theme, loading } = useTeamsFx();

  const [hpbxLoading, setHPBXLoading] = useState(true);

  const [hpbxPeople, setHPBXPeople] = useState([]);
  const [error, setError] = useState("");
  const [warning, setWarning] = useState("");
  const [teamsProfiles, setTeamsProfiles] = useState([]);

  const dispatch = useDispatch();
  const profile = useSelector(state => state.user.userProfile);

  const profiles = useSelector(state => state.users.users);


  //get your profile
  const {
    error: profileGraphError,
  } = useGraph(
    async (graph) => {
      let me = await graph.api("/me").get();
      let photoUrl = "";
      try {
        let photo = await graph.api("/me/photo/$value").get();
        me.photoUrl = URL.createObjectURL(photo);
      } catch {
        // Could not fetch photo from user's profile, return empty string as placeholder.
      }
      await getHPBXLink(me);
      return { profile, photoUrl };
    }
  );

  //useGraph gets a token.
  ////get your team mates profiles
  const {
    error: usersGraphError,
  } = useGraph(
    async (graph) => {
      const profilesObj = await graph.api("/users?$top=999").get();
      let tmpProfiles = profilesObj.value;

      var itemsProcessed = 0;
      let favorites = JSON.parse(localStorage.getItem("favorites"));



      tmpProfiles.forEach(p => {

        if (favorites && favorites.length && favorites.includes(p.id)) {
          p.isFav = true;
        }

        graph.api(`/users/${p.id}/photo/$value`).get()
          .then(photo => {
            p.photoUrl = URL.createObjectURL(photo);
            itemsProcessed++;
            if (itemsProcessed >= tmpProfiles.length) {
              setTeamsProfiles([...tmpProfiles]);
            }
          })
          .catch(err => {
            p.photoUrl = "";
            itemsProcessed++;
            if (itemsProcessed >= tmpProfiles.length) {
              setTeamsProfiles([...tmpProfiles]);
            }
          })

      });

      return;
    }
  );

  useEffect(() => {
    if (profileGraphError) {
      setHPBXLoading(false);
      setError(`Unable to load your Microsoft profile. (${getErrorDetails(profileGraphError)})`);
    }
  }, [profileGraphError]);

  useEffect(() => {
    if (usersGraphError) {
      setWarning(`Unable to load directory users from Microsoft Graph. Some contact/profile features may be limited. (${getErrorDetails(usersGraphError)})`);
    }
  }, [usersGraphError]);

  useEffect(() => {
    async function getHPBXQueues() {

      HPBXService.getHPBXQueues()
        .then(async (res) => {

          //get the agents for the queues as well
          let queues = res.data.data;
          //async / await so don't use foreach here
          for (let i = 0; i < queues.length; i++) {
            let agentRes = await HPBXService.getHPBXQueueAgents(queues[i].server, queues[i].id);
            let agents = agentRes.data.data;
            if (profile.hpbx.length && agents.length > 0) {

              queues[i].agents = agents;

              let hpbxProfile = profile.hpbx.find(id => id.server == queues[i].server);
              if (hpbxProfile) {
                let me = agents.find(a => a.dnumber === hpbxProfile.telephoneLines[0]);
                if (me) {
                  queues[i].loggedIn = 1;
                  queues[i].available = me.available;
                }
              }
            }
          }


          dispatch(updateHPBXQueues(queues));
          setHPBXLoading(false);
          //setHPBXMessage("Queues have been found");
        })
        .catch(err => {
          setHPBXLoading(false);
          setError(`Couldn't load HPBX queues. (${getErrorDetails(err)})`);
        });
    }


    if (profile.hpbx && profile.hpbx.length) {
      getHPBXQueues();
      getContacts();
    } else if (profile.hpbx && !profile.hpbx.length) {
      setHPBXLoading(false);
    }
  }, [profile]);

  useEffect(() => {
    async function getHPBXPeople() {


      HPBXService.getHPBXPeople()
        .then(res => {
          //console.log("GOT BACK ::", res);
          setHPBXPeople(res.data);

          teamsProfiles.forEach(tp => {
            res.data.forEach(hp => {
              if (tp.userPrincipalName === hp.username) {
                //console.log("Found a match:: ", tp.userPrincipalName)
                if (!tp.hpbx) {
                  tp.hpbx = [];
                }
                tp.hpbx.push(hp);
              }
            })
          })


          let result = teamsProfiles.filter(tp => tp.hpbx);
          let hpbxOnlyUser = res.data.filter(hp => {
            for (let tp of result) {
              for (let id of tp.hpbx) {
                if (id.username === hp.username) {
                  return false;
                }
              }

            }
            return true;
          });

          hpbxOnlyUser = hpbxOnlyUser.map(h => {
            return { hpbx: [h], displayName: h.username }
          })

          if (result.length) {

            dispatch(updateUsers(result));
            dispatch(updateHPBXOnlyUsers(hpbxOnlyUser))
            //stop the previous poller and restart it with the new results
            PollerService.restartPresencePoller();

            getGroups();
          }
          else {
            console.log("no profiles - potentially still loading...")
          }



        })
        .catch(err => {
          console.log("GOT BACK AN ERROR:", err)
          setWarning(`Couldn't load HPBX people. (${getErrorDetails(err)})`);
        });
    }

    getHPBXPeople();
  }, [teamsProfiles]);






  async function getGroups() {


    HPBXService.getGroups()
      .then(res => {
        let data = res.data.data;
        console.log(data)
        if (data.length) {
          dispatch(updateGroups(data));
        }
      })
      .catch(err => {
        console.log("GOT BACK AN ERROR:", err)
        setError(`Couldn't load groups. (${getErrorDetails(err)})`);
      });
  }

  async function getContacts() {


    HPBXService.getContacts()
      .then(res => {
        let data = res.data.data;
        if (data.length) {
          dispatch(updateContacts(data));
        }
      })
      .catch(err => {
        console.log("GOT BACK AN ERROR:", err)
        setError(`Couldn't load contacts. (${getErrorDetails(err)})`);
      });
  }



  async function getHPBXLink(msUserProfile) {
    //setHPBXMessage("Please wait... Looking for a linked account...");
    HPBXService.getHPBXLink()
      .then(res => {
        console.log("GOT BACK LINK ::", res);
        let hpbxId = res.data;
        dispatch(updateUserProfile({ ...msUserProfile, hpbx: hpbxId }));
      })
      .catch(err => {
        console.log("GOT BACK AN ERROR:", err)
        dispatch(updateUserProfile({ ...msUserProfile }));
        setHPBXLoading(false);
        setError(`Unable to find matching HPBX account, please check Teams Provisioner and Users in HPBX. (${getErrorDetails(err)})`);

      });
  }


  return (

    <Router>
      <main >
        <div className="" style={{ "overflow-x": "hidden" }}>
          <div className="row">
            <LeftRail></LeftRail>
            <div className="col-sx-12 col-md-8 col-lg-9 col-xxl-10">

              {(error) ? <Alert
                content={error}
                danger
                header="Error"
                visible
              /> : null}

              {(!error && warning) ? <Alert
                content={warning}
                warning
                header="Warning"
                visible
              /> : null}

              {(!error) ? ((loading || hpbxLoading) ? (
                <Loader style={{ margin: 100 }} />
              ) : (
                <>
                  <Route exact path="/privacy" component={Privacy} />
                  <Route exact path="/termsofuse" component={TermsOfUse} />
                  <Route exact path="/mailbox" component={Voicemail} />
                  <Route exact path="/messaging" component={Messaging} />
                  <Route exact path="/transcribe" component={Transcribe} />
                  <Route exact path="/" component={Main} />
                </>
              )) : null}
            </div>
          </div>
        </div>
      </main>
    </Router >
  );
}
